// PhonicsLt03.js
// 包装组件：Letter Teams L03
// 路由：/phonics/lt03
import React from 'react';
import PhonicsLt from './phonics/PhonicsLt';
import { letterDataLt03 } from './phonics/phonics_data_lt03';

function PhonicsLt03() {
  return <PhonicsLt letterData={letterDataLt03} />;
}

export default PhonicsLt03;
